import React from "react";
import { FaRegHospital } from "react-icons/fa";
import { BsFillPersonVcardFill } from "react-icons/bs";
import { BiTimeFive } from "react-icons/bi";
import { FaAmbulance } from "react-icons/fa";
import { GiLovers } from "react-icons/gi";

export default function Advantages() {
  return (
    <>
      <div className="bg-white flex flex-col w-5/6 mx-auto mt-24 lg:mt-12 lg:flex-row ">
        <img
          className="lg:hidden  rounded-lg shadow-lg lg:shadow-xl"
          src="assets/klinikdepan2.jpg"
          alt=""
        />
      </div>

      <div className=" mt-4 flex flex-col w-5/6 mx-auto  2xl:mt-12 lg:flex-row lg:gap-12 xl:gap-24 2xl:gap-14">
        <img
          className="hidden lg:block  lg:w-1/2 xl:w-1/3 rounded-lg shadow-xl"
          src="assets/klinikdepan2.jpg"
          alt=""
        />
        <div className="flex flex-col lg:space-y-10">
          <h1
            className="mt-12 lg:px-0 text-2xl sm:text-4xl  2xl:text-5xl font-bold 2xl:px-20 lg:mt-0"
            id="advantages"
          >
            Mengapa Kami Dipercaya?
          </h1>
          <p className="my-8 lg:my-0 2xl:px-20 2xl:my-8 text-gray-500">
            Klinik Pratama Mora Medika menjadi bagian dari masyarakat yang
            melayani dengan sepenuh hati
          </p>
          <div className="space-y-14 sm:space-y-0 flex flex-col sm:px-0 sm:grid sm:grid-cols-2 sm:gap-x-16 sm:gap-y-12 2xl:gap-x-12 2xl:gap-y-0 2xl:px-20  ">
            <div className="space-y-3 2xl:space-y-5">
              <div className="rounded-full bg-blue-400 w-14 h-14 flex items-center justify-center hover:bg-blue-50 text-white hover:text-gray-600 font-semibold">
                <FaRegHospital className="text-2xl" />
              </div>

              <h2 className="text-xl sm:text-2xl font-semibold">
                Rumah Sakit Rujukan
              </h2>
              <p className="text-gray-500">
                Klinik Mora Medika telah bekerja sama dengan beberapa Rumah
                Sakit rujukan di Cibitung dan sekitarnya. Klinik kami juga
                menyediakan kendaraan khusus bagi pasien rujukan yang
                membutuhkan fasilitas tersebut
              </p>
            </div>

            <div className="space-y-3 2xl:space-y-5">
              <div className="rounded-full bg-blue-400 w-14 h-14 flex items-center justify-center hover:bg-blue-50 text-white hover:text-gray-600 font-semibold">
                <BsFillPersonVcardFill className="text-2xl" />
              </div>

              <h2 className="text-xl sm:text-2xl font-semibold">
                Menerima Pasien BPJS
              </h2>
              <p className="text-gray-500">
                Kami menerima pasien dengan metode BPJS kesehatan
              </p>
            </div>

            <div className="space-y-3 2xl:space-y-5">
              <div className="rounded-full 2xl:mt-12 bg-blue-400 w-14 h-14 flex items-center justify-center hover:bg-blue-50 text-white hover:text-gray-600 font-semibold">
                <BiTimeFive className="text-2xl" />
              </div>

              <h2 className="text-xl sm:text-2xl font-semibold">
                Jam Operasional Klinik
              </h2>
              <p className="text-gray-500">
                Buka setiap hari dengan jam istirahat 12.00 - 13.00 & 18.00 -
                19.00 WIB
              </p>
            </div>

            <div className="space-y-3 2xl:space-y-5">
              <div className="rounded-full 2xl:mt-12 bg-blue-400 w-14 h-14 flex items-center justify-center hover:bg-blue-50 text-white hover:text-gray-600 font-semibold">
                <FaAmbulance className="text-2xl" />
              </div>

              <h2 className="text-xl sm:text-2xl font-semibold">
                Emergency Ambulance
              </h2>
              <p className="text-gray-500">
                Mobil Ambulance yang siap digunakan setiap harinya
              </p>
            </div>

            <div className="space-y-3 2xl:space-y-5 ">
              <div className="rounded-full 2xl:mt-12 bg-blue-400 w-14 h-14 flex items-center justify-center hover:bg-blue-50 text-white hover:text-gray-600 font-semibold">
                <GiLovers className="text-2xl" />
              </div>

              <h2 className="text-xl sm:text-2xl font-semibold">
                Melayani Sepenuh Hati
              </h2>
              <p className="text-gray-500">
                Klinik Pratama Mora Medika menjadi bagian dari masyarakat yang
                melayani dengan sepenuh hati
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
